const JDG = 1;
const SPOLKA_CYWILNA = 2;
const SPOLKA_JAWNA = 3;
const SPOLKA_PARTNERSKA = 4;
const SPOLKA_KOMANDYTOWA = 5;
const SPOLKA_KOMANDYTOWO_AKCYJNA = 6;
const SPOLKA_ZOO = 7;
const SPOLKA_AKCYJNA = 8;
const PROSTA_SPOLKA_AKCYJNA = 9;
const FUNDACJA = 10;
const STOWARZYSZENIE = 11;

export default {
  JDG,
  SPOLKA_CYWILNA,
  SPOLKA_JAWNA,
  SPOLKA_PARTNERSKA,
  SPOLKA_KOMANDYTOWA,
  SPOLKA_ZOO,
  SPOLKA_AKCYJNA,
  PROSTA_SPOLKA_AKCYJNA,
  HAVING_PARTNERS_CRM: [
    SPOLKA_CYWILNA,
    SPOLKA_JAWNA,
    SPOLKA_PARTNERSKA,
  ],
  HAVING_PARTNERS_STAFF: [
    SPOLKA_ZOO,
    SPOLKA_AKCYJNA,
    PROSTA_SPOLKA_AKCYJNA,
    FUNDACJA,
    STOWARZYSZENIE,
  ],
  PARTNERSHIPS: [
    SPOLKA_CYWILNA,
    SPOLKA_JAWNA,
    SPOLKA_PARTNERSKA,
    SPOLKA_ZOO,
    SPOLKA_AKCYJNA,
    PROSTA_SPOLKA_AKCYJNA,
    FUNDACJA,
    STOWARZYSZENIE,
  ],
  USING_CIT: [
    SPOLKA_KOMANDYTOWA,
    SPOLKA_KOMANDYTOWO_AKCYJNA,
    SPOLKA_ZOO,
    SPOLKA_AKCYJNA,
    PROSTA_SPOLKA_AKCYJNA,
    FUNDACJA,
    STOWARZYSZENIE,
  ],
};
